import { useEffect, useState } from "react";
import WOW from 'wowjs';


function BackToTop () {

    const [ scroll, setScroll] = useState<boolean>(false);

    useEffect(
        () => {
            new WOW.WOW({ live: false }).init();
            document.addEventListener("scroll", () => {
                const scrollCheck = window.scrollY > 100;
                setScroll(scrollCheck)
            })
        }, []
    )

    return (
        <>
            {
                scroll && 
                    (
                        <div className="scroll-to-top scroll-to-target d-block tw-cursor-pointer tw-right-5 tw-bottom-24 md:tw-bottom-8 md:tw-right-8" onClick={(event:any) => {
                            const releventDiv:any = document.getElementById("top");
                            releventDiv?.scrollIntoView({behavior: "smooth"});
                        }}>
                            <i className="fas fa-angle-up" />
                        </div>
                    )
            }
        </>
    )

}

export default BackToTop;